package org.multiplatform.kotfolio.pages.portfolio

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.multiplatform.kotfolio.components.AppearanceAwareImage
import org.multiplatform.kotfolio.components.OurValueItem
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Constants
import org.multiplatform.kotfolio.util.Resources

@Page("/portfolio/mosec")
@Composable
fun MosecPage() {
    BlogLayout(
        PageProperties(
            "MoSec",
            "MoSeC is a multivendor Hybrid Platform Flutter material 3.6.0 designed and Dart 4.0.0, rending the application using impreller for its multitude of vendors to list old mobile and sell their inventory hassle-free."
        ),
        BlogProperties("MoSeC", "Mobex Seller Central")
    ) {
        Column(horizontalAlignment = Alignment.Start)
        {
            Box(
                modifier = Modifier.fillMaxSize().padding(topBottom = 1.cssRem),
                contentAlignment = Alignment.Center
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Link(
                        path = "https://vendormosec.netlify.app",
                        text = "MoSeC",
                        modifier = Modifier
                            .margin(right = 4.px)
                    )
                    AppearanceAwareImage(
                        src = Resources.Images.NAVIGATION_ARROW
                    )
                }
            }

            SpanText(
                text = Constants.MOSEC_INTRO_1,
                modifier = Modifier
                    .fontSize(FontSize.Medium)
            )

            SpanText(
                text = Constants.MOSEC_INTRO_2,
                modifier = Modifier
                    .fontSize(FontSize.Medium)
            )

            SpanText(
                text = Constants.MOSEC_INTRO_3,
                modifier = Modifier
                    .fontSize(FontSize.Medium)
            )


            SimpleGrid(
                numColumns = numColumns(
                    base = 1,
                    md = 2
                ),
                modifier = Modifier.margin(top = 20.px)
            ) {
                OurValueItem(
                    title = "Seller Dashboard",
                    description = "Quick view and navigation through dashboard."
                )
                OurValueItem(
                    title = "Product Listing",
                    description = "Listing of the products directly by the seller."
                )
                OurValueItem(
                    title = "Product Un-listing",
                    description = "In case the product is sold off by the seller itself and want to de-list, it can be done by them"
                )
                OurValueItem(
                    title = "Financial Seller Reports",
                    description = "Reports of total sales and devices including grades."
                )
            }

            Column {
                SimpleGrid(
                    modifier = Modifier.fillMaxWidth(),
                    numColumns = numColumns(base = 1, md = 3)
                ) {
                    Box {
                        Image(
                            modifier = Modifier.fillMaxWidth().padding(all = 1.cssRem),
                            src = "https://vendormosec.netlify.app/image/dashboard.png",
                            description = "MoSec"
                        )
                    }

                    Image(
                        modifier = Modifier.fillMaxWidth().padding(all = 1.cssRem),
                        src = "https://vendormosec.netlify.app/image/product_entry_choose_model.png",
                        description = "MoSec"
                    )

                    Image(
                        modifier = Modifier.fillMaxWidth().padding(all = 1.cssRem),
                        src = "https://vendormosec.netlify.app/image/product_entry_form.png",
                        description = "MoSec"
                    )
                }
            }
        }
    }
}

